import { render, staticRenderFns } from "./CharacteristicsView.vue?vue&type=template&id=6c1e46f0&scoped=true&"
import script from "./CharacteristicsView.vue?vue&type=script&lang=js&"
export * from "./CharacteristicsView.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicsView.vue?vue&type=style&index=0&id=6c1e46f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e46f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
